import React, { Component } from "react";
import { Layouts } from "../constants/Constants";
import { connect } from "react-redux";
import { isContentifiable } from "./Contentify";
import { mapStateToProps } from "./ContentHelper";

export const ContentNotFoundMessage = "Content not found";

export function getContent(
  reduxState,
  unprocessedContent,
  contentFunctionParams
) {
  let result = ContentNotFoundMessage;

  if (unprocessedContent) {
    if (
      typeof unprocessedContent === "string" ||
      typeof unprocessedContent === "function" ||
      React.isValidElement(unprocessedContent)
    ) {
      result = unprocessedContent;
    }

    if (typeof unprocessedContent === "object") {
      if (
        reduxState.shouldShowClaims &&
        unprocessedContent.hasOwnProperty("Claims")
      ) {
        result = unprocessedContent.Claims;
      } else if (
        reduxState.shouldShowFastTrack &&
        unprocessedContent.hasOwnProperty("FastTrack")
      ) {
        result = unprocessedContent.FastTrack;
      } else if (
        reduxState.CurrentPolicy &&
        reduxState.CurrentPolicy.IsInternational &&
        unprocessedContent.hasOwnProperty("International")
      ) {
        result = unprocessedContent.International;
      } else if (
        reduxState.CurrentPolicy &&
        reduxState.CurrentPolicy.IsFormat2 &&
        !reduxState.CurrentPolicy.IsHealthSelect &&
        unprocessedContent.hasOwnProperty("Format2AndNonHealthSelect")
      ) {
        result = unprocessedContent.Format2AndNonHealthSelect;
      } else if (
        reduxState.CurrentPolicy &&
        reduxState.CurrentPolicy.IsSaga &&
        unprocessedContent.hasOwnProperty("Saga")
      ) {
        result = unprocessedContent.Saga;
      } else if (
        reduxState.CurrentPolicy &&
        reduxState.CurrentPolicy.IsLargeCorporate &&
        unprocessedContent.hasOwnProperty("LargeCorporate")
      ) {
        result = unprocessedContent.LargeCorporate;
      } else if (
        reduxState.CurrentPolicy &&
        reduxState.CurrentPolicy.IsSME &&
        unprocessedContent.hasOwnProperty("SME")
      ) {
        result = unprocessedContent.SME;
      } else if (
        reduxState.CurrentPolicy &&
        reduxState.CurrentPolicy.IsHealthSelect &&
        unprocessedContent.hasOwnProperty("HealthSelect")
      ) {
        result = unprocessedContent.HealthSelect;
      } else if (
        reduxState.CurrentPolicy &&
        reduxState.CurrentPolicy.IsFormat2 &&
        unprocessedContent.hasOwnProperty("Format2SMEandLargeCorporate") && 
        (reduxState.CurrentPolicy.IsSME || reduxState.CurrentPolicy.IsSMEModular || reduxState.CurrentPolicy.IsLargeCorporate)
      ) {
        result = unprocessedContent.Format2SMEandLargeCorporate;
      } else if (
        reduxState.CurrentPolicy &&
        reduxState.CurrentPolicy.IsFormat2 &&
        unprocessedContent.hasOwnProperty("Format2")
      ) {
        result = unprocessedContent.Format2;
      } else if (
        reduxState.CurrentPolicy &&
        reduxState.CurrentPolicy.IsLapsed &&
        unprocessedContent.hasOwnProperty("Lapsed")
      ) {
        result = unprocessedContent.Lapsed;
      } else if (
        reduxState.CurrentPolicy &&
        reduxState.CurrentPolicy.IsSMEModular &&
        unprocessedContent.hasOwnProperty("SMEModular")
      ) {
        result = unprocessedContent.SMEModular;
      } else if (
        reduxState.Layout &&
        reduxState.Layout === Layouts.MOL &&
        reduxState.CurrentPolicy &&
        reduxState.CurrentPolicy.MembershipNumber &&
        reduxState.CurrentPolicy.MembershipNumber.search("HOL") === 0 &&
        unprocessedContent.hasOwnProperty("HOLMOL")
      ) {
        result = unprocessedContent.HOLMOL;
      } else if (
        (reduxState.Layout === Layouts.MOL || !reduxState.Layout) &&
        unprocessedContent.hasOwnProperty("MOL")
      ) {
        result = unprocessedContent.MOL;
      } else if (
        reduxState.Layout === Layouts.HOL &&
        unprocessedContent.hasOwnProperty("HOL")
      ) {
        result = unprocessedContent.HOL;
      } else if (
        reduxState.CurrentPolicy && 
        reduxState.CurrentPolicy.IsSME &&
        unprocessedContent.hasOwnProperty("SMEonly")
      ) {
        result = unprocessedContent.SMEonly;
      } else if (unprocessedContent.hasOwnProperty("Any")) {
        result = unprocessedContent.Any;
      }
    }
  } else if (unprocessedContent === null) {
    result = null;
  }

  if (typeof result === "function") {
    result = result.call(this, reduxState, contentFunctionParams);
  }

  if (isContentifiable(result)) {
    result = getContent(reduxState, result, contentFunctionParams);
  }

  return result;
}

class Content extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.getContent = getContent;
  }

  render() {
    let childFunc;
    if (this.props.children) {
      if (typeof this.props.children === "function") {
        childFunc = this.props.children;
      } else if (
        Array.isArray(this.props.children) &&
        this.props.children.length >= 2
      ) {
        if (typeof this.props.children[0] === "function") {
          childFunc = this.props.children[0];
        } else if (typeof this.props.children[1] === "function") {
          childFunc = this.props.children[1];
        }
      }
    }

    if (childFunc) {
      if (this.props.names) {
        return childFunc(
          ...this.props.names.map((name) =>
            this.getContent(this.props, name, this.props.params)
          )
        );
      }
      return childFunc(
        this.getContent(this.props, this.props.name, this.props.params)
      );
    }
    return this.getContent(this.props, this.props.name, this.props.params);
  }
}

export default connect(mapStateToProps)(Content);
